// React Thirty Party Library
import {
  Typography,
  Badge,
  Select,
} from "antd";

// Constant
import { ROOT_CONSTANT, TEMPLATE } from "../../../constants";

// Components
import { ButtonLink } from "../../../components";

//handlers
import { filter } from "../../../handlers";

// Service Library
import { TIME } from "../../../services/util";

const {
  TABLE_COMPANY_TITLE,
  TABLE_COMPANY_INDEX,
  COMPANY_STATUS_TITLE,
  EXPAND_TABLE_COMPANY_INDEX,
  EXPAND_TABLE_COMPANY_TITLE,
  BLOCK_STATUS_TITLE,
  BLOCK_STATUS_OPTIONS,
} = TEMPLATE.COMPANY;

const { parseTimeMin } = TIME;

const { searchHDLR, filterHDLR } = filter;

const { Text } = Typography;

const { icon_comment } = ROOT_CONSTANT.IMG.ICON;
const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;

const getProgressColor = (value, eligAmount) => {
  if (value < eligAmount) {
    // green
    return {
      "0%": "#4CAF50",
      "100%": "#204921",
    };
  } else if (value >= eligAmount + 500) {
    // red
    return {
      "0%": "#FF0000",
      "100%": "#990000",
    };
  } else {
    // yellow
    return {
      "0%": "#FFE500",
      "100%": "#FFBA34",
    };
  }
};

export const COMPANY_SUMMARY_COL = ({
  func = {},
  redux = {},
  exportState = false,
}) => {
  const {
    handleSearch,
    handleRequestStatus,
    dispatch,
    messageApi,
    DrawerRemark,
  } = func;
  const { user, company = {} } = redux;

  return [
    {
      title: TABLE_COMPANY_TITLE.CompanyID,
      key: TABLE_COMPANY_INDEX.CompanyID,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { coid } = record;
        return exportState ? coid : <Text>{coid} </Text>;
      },
      ...searchHDLR.getColumnSearchProps("coid", handleSearch),
    },
    {
      title: TABLE_COMPANY_TITLE.Status,
      key: TABLE_COMPANY_INDEX.Status,
      fixed: "left",
      render: (record) => {
        const { status } = record;

        const { name, colorTag, bgColor } = COMPANY_STATUS_TITLE[status];

        return exportState ? (
          name
        ) : (
          <div
            style={{
              backgroundColor: bgColor,
              display: "inline-block",
              padding: "3px 13px",
              borderRadius: "30px",
            }}
          >
            <Badge
              color={colorTag}
              text={<span style={{ color: colorTag }}>{name}</span>}
            />
          </div>
        );
      },
      filters: filterHDLR.getColumnsFilterStatus(COMPANY_STATUS_TITLE),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: TABLE_COMPANY_TITLE.Name,
      key: TABLE_COMPANY_INDEX.Name,
      width: 200,
      render: (record) => {
        const { name, short_code, regis_number } = record;
        return exportState ? (
          name
        ) : (
          <span>
            <Text>{name}/{regis_number? regis_number : "-"} </Text>
            {/* <br />
            <Text> </Text> */}
          </span>
        );
      },
      filters: filterHDLR.getColumnsCompanyName(company),
      onFilter: (value, record) => value.includes(record.name),
      filterSearch: true,
    },
    {
      title: TABLE_COMPANY_TITLE.ShortCode,
      key: TABLE_COMPANY_INDEX.ShortCode,
      width: 100,
      render: (record) => {
        const { short_code } = record;
        return exportState ? (
          short_code
        ) : (
          <Text>{short_code}</Text>
        );
      }
    },
    ...(exportState
      ? [
          {
            title: TABLE_COMPANY_TITLE.Regis_Number,
            width: 200,
            render: (record) => {
              const { regis_number } = record;
              
              return exportState ? regis_number : <Text>{regis_number}</Text>;
            },
          },
        ]
      : []),
    {
      title: TABLE_COMPANY_TITLE.ReqStatus,
      key: TABLE_COMPANY_INDEX.ReqStatus,
      render: (record) => {
        const { isBlocked } = record;

        const { name } = BLOCK_STATUS_TITLE[isBlocked || -1];

        return exportState ? (
          name
        ) : (
          <Select
            variant="borderless"
            options={BLOCK_STATUS_OPTIONS}
            defaultValue={isBlocked}
            onChange={(value) =>
              handleRequestStatus(value, dispatch, messageApi, user, record)
            }
            style={{ width: "8rem" }}
          />
        );
      },
      filters: filterHDLR.getColumnsFilterStatus(BLOCK_STATUS_TITLE),
      onFilter: (value, record) => record.isBlocked === value,
    },
    {
      title: TABLE_COMPANY_TITLE.LoyaltyProgram,
      key: TABLE_COMPANY_INDEX.LoyaltyProgram,
      width: 200,
      render: (record) => {
        const { loyaltyName } = record;
        return exportState ? loyaltyName : <Text>{loyaltyName} </Text>;
      },
    },
    {
      title: TABLE_COMPANY_TITLE.Privilege,
      key: TABLE_COMPANY_INDEX.Privilege,
      width: 200,
      render: (record) => {
        const { privilege } = record;
    
        if (exportState) {
          return privilege; 
        } else {
          return privilege ? (
            <div
              style={{
                display: "inline-block",
                padding: "3px 13px",
                borderRadius: "30px",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "black",
              }}
            >
              {privilege}
            </div>
          ) : null;
        }
      },
    },
    ...(!exportState
      ? [
          {
            title: TABLE_COMPANY_TITLE.PIC,
            key: TABLE_COMPANY_INDEX.PIC,
            width: 200,
            render: (record) => {
              const { pic, picName } = record;
              const formattedContact = pic?.contact.replace(
                "+",
                `<img src=${icon_malaysia} alt="Malaysia" style="width: 20px; height: 15px; border-radius: 50%; margin-right: 5px;"/>`
              );
              return (
                <span>
                  <Text>{picName} </Text>
                  <br />
                  <span dangerouslySetInnerHTML={{ __html: formattedContact }} />
                </span>
              );
            },
            ...searchHDLR.getColumnSearchProps("picName", handleSearch),
          },
        ]
      : []),

      ...(exportState
        ? [
            {
              title: TABLE_COMPANY_TITLE.PIC_Name,
              width: 200,
              render: (record) => {
                const { pic } = record;

                const PIC_Name = pic ? pic.name : " ";
                
                return exportState ? PIC_Name : <Text>{PIC_Name}</Text>;
              },
            },
            {
              title: TABLE_COMPANY_TITLE.PIC_Contact,
              width: 200,
              render: (record) => {
                const { pic } = record;

                const PIC_Contact = pic ? pic.contact : " ";
                
                return exportState ? PIC_Contact : <Text>{PIC_Contact}</Text>;
              },
            },
          ]
        : []),
    ...(!exportState
      ? [
          {
            title: TABLE_COMPANY_TITLE.TotalEmployer,
            key: TABLE_COMPANY_INDEX.TotalEmployer,
            render: (record) => {
              const { detailEmployer } = record;
              
              return (
                <span>
                  <Text>Active/Suspended</Text>
                  <br />
                  <Text>
                    {detailEmployer?.active}/{detailEmployer?.suspend}{" "}
                  </Text>
                </span>
              );
            },
          },
          {
            title: TABLE_COMPANY_TITLE.TotalEmployee,
            key: TABLE_COMPANY_INDEX.TotalEmployee,
            render: (record) => {
              const { detailEmployee } = record;
              return (
                <span>
                  <Text>Created/Active/Suspended</Text>
                  <br />
                  <Text>
                    {detailEmployee?.created}/{detailEmployee?.active}/
                    {detailEmployee?.suspend}
                  </Text>
                </span>
              );
            },
          },
        ]
      : []),

    ...(exportState
      ? [
          {
            title: TABLE_COMPANY_TITLE.TotalActiveEmployer,
            width: 200,
            render: (record) => {
              const { detailEmployer } = record;

              const detailEmployerActive = detailEmployer?.active ?? 0;
              
              return exportState ? detailEmployerActive : <Text>{detailEmployerActive}</Text>;
            },
          },
          {
            title: TABLE_COMPANY_TITLE.TotalSuspendedEmployer,
            width: 200,
            render: (record) => {
              const { detailEmployer } = record;

              const detailEmployerSuspended = detailEmployer?.suspend ?? 0;
              
              return exportState ? detailEmployerSuspended : <Text>{detailEmployerSuspended}</Text>;
            },
          },
          {
            title: TABLE_COMPANY_TITLE.TotalCreatedEmployee,
            width: 200,
            render: (record) => {
              const { detailEmployee } = record;

              const detailEmployeeCreated = detailEmployee?.created ?? 0;
              
              return exportState ? detailEmployeeCreated : <Text>{detailEmployeeCreated}</Text>;
            },
          },
          {
            title: TABLE_COMPANY_TITLE.TotalActiveEmployee,
            width: 200,
            render: (record) => {
              const { detailEmployee } = record;

              const detailEmployeeActive = detailEmployee?.active ?? 0;
              
              return exportState ? detailEmployeeActive : <Text>{detailEmployeeActive}</Text>;
            },
          },
          {
            title: TABLE_COMPANY_TITLE.TotalSuspendedEmployee,
            width: 200,
            render: (record) => {
              const { detailEmployee } = record;

              const detailEmployeeSuspended = detailEmployee?.suspend ?? 0;
              
              return exportState ? detailEmployeeSuspended : <Text>{detailEmployeeSuspended}</Text>;
            },
          },
        ]
      : []),

    {
      title: TABLE_COMPANY_TITLE.BillingDate,
      key: TABLE_COMPANY_INDEX.BillingDate,
      render: (record) => {
        const { billing_date } = record;
        return exportState ? (
          TIME.getDayNumberFromEpochWithSuffix(billing_date)
        ) : (
          <Text>{TIME.getDayNumberFromEpochWithSuffix(billing_date)} </Text>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_COMPANY_TITLE.Period,
      key: TABLE_COMPANY_INDEX.Period,
      render: (record) => {
        const { billing_period } = record;
        return exportState ? (
          TIME.getDayNumberFromEpoch(billing_period)
        ) : (
          <Text>{TIME.getDayNumberFromEpoch(billing_period)} days</Text>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_COMPANY_TITLE.GlCode,
      key: TABLE_COMPANY_INDEX.GlCode,
      render: (record) => {
        const { glcode } = record;
        return exportState ? glcode : <Text>{glcode} </Text>;
      },
    },
    {
      title: TABLE_COMPANY_TITLE.CreatedAt,
      key: TABLE_COMPANY_INDEX.CreatedAt,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = `${createdBy_name} /${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}{" "}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_COMPANY_TITLE.UpdatedAt,
      key: TABLE_COMPANY_INDEX.UpdatedAt,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = updatedBy ? `${updatedBy_name} /${updatedBy}` : "-"
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_COMPANY_TITLE.Remarks,
      key: TABLE_COMPANY_INDEX.Remarks,
      fixed: "right",
      render: (record) => {
        const { remarkCount } = record;

        return (
          <Badge
            count={remarkCount || 0}
            showZero
            offset={[12, 10]}
            color="#0E2483"
          >
            <ButtonLink
              onClick={() => {
                DrawerRemark(record);
              }}
            >
              <img src={icon_comment} alt="" />
            </ButtonLink>
          </Badge>
        );
      },
    },
  ];
};

export const EXPAND_COMPANY_SUMMARY_COL = ({
  func = {},
  exportState = false,
}) => {
  const { handleSearch } = func;

  return [
    {
      title: EXPAND_TABLE_COMPANY_TITLE.revisiion,
      key: EXPAND_TABLE_COMPANY_INDEX.revisiion,
      width: 110,
      render: (record) => {
        const { revision } = record;
        return exportState ? revision : <Text>{revision} </Text>;
      },
      ...searchHDLR.getColumnSearchProps("revision", handleSearch),
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.limit,
      key: EXPAND_TABLE_COMPANY_INDEX.limit,
      // width: 170,
      render: (record) => {
        const { limit } = record;

        return exportState ? limit : <p>RM {limit}</p>;
      },
      ...searchHDLR.getColumnSearchProps("limit", handleSearch),
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.deposit_from,
      key: EXPAND_TABLE_COMPANY_INDEX.deposit_from,
      width: 210,
      render: (record) => {
        const { deposit_from } = record;
        return exportState ? deposit_from : <Text>{deposit_from} </Text>;
      },
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.deposit_adjustment,
      key: EXPAND_TABLE_COMPANY_INDEX.deposit_adjustment,
      width: 250,
      render: (record) => {
        const { deposit_adjustment } = record;
        return exportState ? (
          deposit_adjustment
        ) : (
          <Text>{deposit_adjustment} </Text>
        );
      },
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.deposit_to,
      key: EXPAND_TABLE_COMPANY_INDEX.deposit_to,
      width: 200,
      render: (record) => {
        const { deposit_to } = record;
        return exportState ? deposit_to : <Text>{deposit_to} </Text>;
      },
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.deposit_receipt,
      key: EXPAND_TABLE_COMPANY_INDEX.deposit_receipt,
      render: (record) => {
        const { attachment } = record;

        const attach = attachment?.receipt ? (
          <ButtonLink>Download</ButtonLink>
        ) : (
          <></>
        );

        return exportState ? attachment?.receipt : attach;
      },
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.deposit_offer,
      key: EXPAND_TABLE_COMPANY_INDEX.deposit_offer,
      render: (record) => {
        const { attachment } = record;

        const attach = attachment?.offer ? (
          <ButtonLink>Download</ButtonLink>
        ) : (
          <></>
        );

        return exportState ? attachment?.offer : attach;
      },
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.updatedAt,
      key: EXPAND_TABLE_COMPANY_INDEX.updatedAt,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = `${updatedBy_name} /${updatedBy}`
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: EXPAND_TABLE_COMPANY_TITLE.createdAt,
      key: EXPAND_TABLE_COMPANY_INDEX.createdAt,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = `${createdBy_name} /${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}
          </span>
        );
      },
      sorter: true,
    },
  ];
};
